<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";
    import { apiUrl } from "@/utils";

    export default {
        name: "PromoDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                modelsList: [],
                versionsList: [],
                form: {
                    blocks: [],
                    images: [],
                    minVersionId: null,
                    modelId: null,
                    vendorId: "",
                    name: "",
                    seo: {
                        description: "",
                        keywords: "",
                        slug: "",
                        title: "",
                    },
                    videoCode: "",
                    status: "published",
                    sort: 0,
                },
                dropFiles: [],
                isLoading: false,
                nameBlock: "",
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить промо",
                    view: "Промо",
                    edit: "Редактировать промо",
                };
                return filtered[this.statusPage];
            },
        },
        watch: {
            "form.modelId"(id) {
                if (id) {
                    this.getVersions(id);
                }
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
            this.getModels();
        },
        methods: {
            apiUrl,
            send() {
                this.form.blocks = [];
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "PromoEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.form.blocks.push({ title: this.nameBlock, html: "<div></div>" });
                this.$store.autoAdminApi
                    .editPromo(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "PromoList",
                        });
                    });
            },
            handlerForCreate() {
                this.form.blocks.push({ title: this.nameBlock, html: "<div></div>" });
                this.$store.autoAdminApi.createPromo(this.form).then(({ data }) => {
                    this.$router.push({
                        name: "PromoList",
                    });
                });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi.getPromo(this.$route.params.slug).then(({ data }) => {
                    this.form = data;
                    if (this.form.blocks.length > 0) {
                        this.nameBlock = this.form.blocks[0].title;
                    }
                });
            },
            getModels() {
                this.$store.autoAdminApi.getModels().then(({ data }) => {
                    this.modelsList = data.items;
                });
            },
            getVersions(id) {
                this.$store.autoAdminApi.getVersions(id).then(({ data }) => {
                    this.versionsList = data.items;
                });
            },
            deleteDropFile(index) {
                this.dropFiles.splice(index, 1);
            },
            fileConversion() {
                this.isLoading = true;
                let fileList = [];
                let formData = new FormData();
                this.dropFiles.forEach((file, i) => {
                    formData.append(`photo${i}`, file);
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        fileList.push(fileReader.result);
                        if (this.dropFiles.length === fileList.length) {
                            this.uploadPhoto(fileList);
                        }
                    };
                    fileReader.readAsDataURL(file);
                });
            },
            uploadPhoto(file) {
                this.$store.autoAdminApi
                    .uploadImages({ file })
                    .then(({ data }) => {
                        data.id.forEach((id) => {
                            this.form.images.push({
                                alt: "",
                                imageId: id,
                                sort: 0,
                            });
                        });
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            removeImage(index) {
                this.form.images.splice(index, 1);
            },
            selectModel(id) {
                let currentModal = this.modelsList.find((model) => model.id === id);
                this.form.vendorId = currentModal.vendorId;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="model-detail">
        <the-detail-wrapper
            :title="title"
            type-list="/promo-list"
            :current-status="statusPage"
            @handler-submit="send"
        >
            <b-loading
                :is-full-page="true"
                v-model="isLoading"
                :can-cancel="false"
            ></b-loading>

            <b-field label="Наименование">
                <b-input v-model="form.name"></b-input>
            </b-field>
            <b-field
                label="Код видео вставки"
                message="id youtube(после слэша) https://youtu.be/76tvChUpOCQ"
            >
                <b-input v-model="form.videoCode"></b-input>
            </b-field>
            <b-field label="Название промо-блока">
                <b-input v-model="nameBlock"></b-input>
            </b-field>

            <b-field label="Производитель">
                <b-input v-model="form.vendorId" disabled></b-input>
            </b-field>

            <b-field label="Модель">
                <b-select
                    placeholder="Выбрать модель"
                    v-model="form.modelId"
                    @input="selectModel"
                >
                    <option :value="model.id" v-for="model in modelsList" :key="model.id">
                        {{ model.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field v-show="form.modelId" label="Минимальная Комплектация">
                <b-select placeholder="Выбрать комплектацию" v-model="form.minVersionId">
                    <option
                        :value="version.id"
                        v-for="version in versionsList"
                        :key="version.id"
                    >
                        {{ version.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field label="Статус">
                <b-select placeholder="Выбрать статус" v-model="form.status">
                    <option value="published">Опубликованный</option>
                    <option value="draft">Черновой</option>
                </b-select>
            </b-field>
            <b-field label="Сортировка">
                <b-input v-model.number="form.sort"></b-input>
            </b-field>

            <b-field label="Seo" custom-class="is-large"></b-field>
            <b-field label="Заголовок">
                <b-input v-model="form.seo.title"></b-input>
            </b-field>
            <b-field label="Описание">
                <b-input v-model="form.seo.description"></b-input>
            </b-field>
            <b-field label="Slug">
                <b-input v-model="form.seo.slug"></b-input>
            </b-field>
            <b-field label="Keywords">
                <b-input v-model="form.seo.keywords"></b-input>
            </b-field>

            <b-field label="Галерея" custom-class="is-large" message="Размеры 2016x900">
            </b-field>
            <b-field>
                <b-upload v-model="dropFiles" multiple drag-drop>
                    <section class="section">
                        <div class="content has-text-centered">
                            <p>
                                <b-icon icon="upload" size="is-large"></b-icon>
                            </p>
                            <p>Перетащить или кликнуть</p>
                        </div>
                    </section>
                </b-upload>
            </b-field>

            <div class="tags">
                <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
                    {{ file.name }}
                    <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFile(index)"
                    ></button>
                </span>
            </div>
            <div v-if="form.images.length > 0" class="preview-images-list">
                <div
                    v-for="(img, index) in form.images"
                    :key="img.imageId"
                    class="preview-images-list__item"
                >
                    <img :src="apiUrl('/gallery/image/' + img.imageId + '.orig')" alt="" />
                    <button @click="removeImage(index)">
                        <b-icon icon="close" size="is-small"></b-icon>
                    </button>
                    <b-field label="Сортировка" custom-class="is-small">
                        <b-input v-model.number="img.sort"></b-input>
                    </b-field>
                </div>
            </div>
            <div v-show="dropFiles.length > 0" class="field is-grouped">
                <p class="control">
                    <b-button type="is-primary is-light" outlined @click="fileConversion">
                        Загрузить галерею
                    </b-button>
                </p>
            </div>
        </the-detail-wrapper>
    </div>
</template>

<style lang="scss"></style>
